import { disallowedJWTRoutes } from '../constants';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports -- UtilsService used for DI in factory deps
import { UtilsService } from '../services/helpers/utils.service';

export const jwtOptionsFactory = (utils: UtilsService) => ({
  tokenGetter: () => utils.storage.token,
  authScheme: 'JWT ',
  disallowedRoutes: disallowedJWTRoutes,
});
